<template>
  <v-container fluid class="theme-color" style="height: 100%;">
    <v-row class="card pb-4 mt-5" justify-space-between>
      <v-col cols="12">
        <Search @getSearchCondition="updateCondition" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Search from '../components/dashboard-air/Search.vue';

export default {
  name: 'DashboardAir',
  components: {
    Search
  },
  data: () => ({
    condition: null
  }),
  mounted() {
    this.$emit('sethambergervisible', false);
  },
  methods: {
    updateCondition(value) {
      this.condition = value;
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  width: 85% !important;
  background: none;
  margin: auto;
}

.col {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
